(function () {
  function dateAllowed(value, today) {
    if (!value) return true;
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
    var date = new Date(value + 'T12:00:00Z');
    return !Number.isNaN(date.getTime()) && date.toISOString().slice(0, 10) === value && value >= today;
  }

  /* 26 Out: o extra vem da etiqueta da cobertura, ex. "A personalizar (+3 €)" ou "Calda de laranja (+2 €)" */
  function extraCents(label) {
    var m = /\(\+\s*(\d+(?:,\d{1,2})?)\s*€\)/.exec(String(label || ''));
    return m ? Math.round(parseFloat(m[1].replace(',', '.')) * 100) : 0;
  }

  function formatExtra(cents, en) {
    /* 26 Out 2026: extras sempre com cêntimos, «+ 2,00 €» */
    var v = (cents / 100).toFixed(2);
    return en ? '€' + v : v.replace('.', ',') + ' €';
  }

  /* 26 Out 2026: redação única das mensagens de WhatsApp (produto, menu, carrinho).
     Rótulos em negrito do WhatsApp, campos vazios omitidos, nunca duas linhas vazias seguidas. */
  var PICKUP = 'Recolha na Pontinha';
  var EN = {
    'Formato': 'Format', 'Sabores': 'Flavours', 'Cobertura': 'Topping', 'Personalização': 'Customisation',
    'Mensagem no bolo': 'Message on the cake', 'Quantidade': 'Quantity', 'Data': 'Date',
    'Receção': 'Getting your order', 'Alergias': 'Allergies',
    'Observações': 'Notes', 'Preço': 'Price', 'Total': 'Total', 'Total do pedido': 'Order total',
    'a combinar na conversa': 'to be agreed in the chat',
    'Recolha na Pontinha': 'Collection in Pontinha',
    'Sem cobertura': 'No topping', 'A personalizar': 'Custom', 'Calda de laranja': 'Orange syrup',
    'Sem calda': 'No syrup', 'Calda de açúcar': 'Sugar syrup'
  };
  var OPENING = {
    order: ["Olá, Larrysa's Bakery! Tudo bem? Gostaria de fazer uma encomenda:", "Hello, Larrysa's Bakery! How are you? I'd like to place an order:"],
    party: ["Olá, Larrysa's Bakery! Tudo bem? Gostaria de pedir um orçamento para uma festa.", "Hello, Larrysa's Bakery! How are you? I'd like to ask for a quote for a party."]
  };
  var CLOSING = ['Podem confirmar a disponibilidade e o valor final? Obrigado!', 'Could you confirm availability and the final price? Thank you!'];

  function word(pt, en) {
    if (!en) return pt;
    if (EN[pt]) return EN[pt];
    var t = window.larrysaT ? window.larrysaT(pt) : pt;
    return t;
  }
  function money(cents, en) {
    var v = (Math.round(cents) / 100).toFixed(2);
    return en ? '€' + v : v.replace('.', ',') + ' €';
  }
  function unitPrice(label, en) {
    var m = /^(\d+),(\d{2})\s?€$/.exec(String(label || '').trim());
    return m && en ? '€' + m[1] + '.' + m[2] : label;
  }
  function plainTopping(label) { return String(label || '').replace(/\s*\(\+\s*€?\s*\d+(?:[.,]\d{1,2})?\s*€?\)\s*$/, '').trim(); }
  function isCustomTopping(label) { return /^a personalizar/i.test(String(label || '').trim()); }
  function toppingText(label, en) {
    var plain = plainTopping(label);
    if (!en) return plain;
    if (EN[plain]) return EN[plain];
    var t = window.larrysaT ? plainTopping(window.larrysaT(label)) : plain;
    return t || plain;
  }
  function formatDate(iso) {
    var p = String(iso || '').split('-');
    return p.length === 3 ? p[2] + '/' + p[1] + '/' + p[0] : String(iso || '');
  }
  function field(label, value, en) {
    value = value == null ? '' : String(value).trim();
    return value ? '*' + word(label, en) + ':* ' + value : '';
  }
  function compose(blocks) {
    return blocks.map(function (b) { return (Array.isArray(b) ? b : [b]).filter(function (l) { return l && String(l).trim(); }).join('\n'); })
      .filter(Boolean).join('\n\n');
  }
  function variantText(v, en) {
    if (!v || /^Default(?: Title)?$/i.test(v)) return '';
    if (!en) return v;
    var t = window.larrysaT ? window.larrysaT(v) : v;
    return t === v ? v.replace(/^(\d+) unidades$/, '$1 units') : t;
  }
  /* item: {name, realName, variant, flavours, topping, custom, cakeMessage, quantity, date, reception, zone, allergies, notes, unitCents, unitPrice} */
  function itemLines(item, en, index) {
    en = false;
    var q = Number(item.quantity) || 1, xc = extraCents(item.topping), unit = Number(item.unitCents) || 0;
    var lines = ['*' + (index ? index + '. ' : '') + (en && window.larrysaT ? window.larrysaT(item.name) : item.name) + '*' + (item.realName ? ' (' + (en && window.larrysaT ? window.larrysaT(item.realName) : item.realName) + ')' : '')];
    lines.push(field('Formato', variantText(item.variant, en), en));
    lines.push(field('Sabores', item.flavours ? (en && window.larrysaT ? window.larrysaT(item.flavours) : item.flavours) : '', en));
    if (item.topping) lines.push(field('Cobertura', toppingText(item.topping, en) + (xc ? ' (+ ' + formatExtra(xc, en) + ')' : ''), en));
    if (isCustomTopping(item.topping)) lines.push(field('Personalização', item.custom || word('a combinar na conversa', en), en));
    else lines.push(field('Personalização', item.custom, en));
    lines.push(field('Mensagem no bolo', item.cakeMessage, en));
    lines.push(field('Quantidade', String(q), en));
    if (!item.sharedDate) lines.push(field('Para quando precisa?', item.date ? formatDate(item.date) : 'Data a combinar', en));
    /* 26 Out 2026: só recolha na Pontinha; a linha segue sempre, sem zona nem morada. */
    if (!item.sharedReception) lines.push(field('Receção', word(PICKUP, en), en));
    lines.push(field('Alergias ou intolerâncias', item.allergies || 'A indicar na conversa', en));
    lines.push(field('Observações', item.notes, en));
    if (unit) {
      var each = unit + xc;
      lines.push(field('Preço', xc ? money(unit, en) + ' + ' + formatExtra(xc, en) + ' = ' + money(each, en) : money(unit, en), en));
      if (q > 1) lines.push('*' + word('Total', en) + ' (' + q + ' ' + (en ? 'units' : 'unidades') + '):* ' + money(each * q, en));
    }
    return lines;
  }
  function itemTotal(item) { return ((Number(item.unitCents) || 0) + extraCents(item.topping)) * (Number(item.quantity) || 1); }
  function orderText(items, opts) {
    opts = opts || {};
    var en = false, blocks = [OPENING.order[en ? 1 : 0]];
    var shared = [];
    if (items.length > 1) {
      shared = ['date'].filter(function (k) {
        var v = items[0][k] || '';
        return items.every(function (it) { return (it[k] || '') === v; });
      });
    }
    items.forEach(function (it, i) {
      var copy = {}; Object.keys(it).forEach(function (k) { copy[k] = shared.indexOf(k) >= 0 ? '' : it[k]; });
      if (items.length > 1) { copy.sharedReception = true; copy.sharedDate = true; }
      blocks.push(itemLines(copy, en, items.length > 1 ? i + 1 : 0));
    });
    if (items.length > 1) {
      var total = items.reduce(function (n, it) { return n + itemTotal(it); }, 0), tail = [];
      if (total) tail.push('*' + word('Total do pedido', en) + ':* ' + money(total, en));
      var first = items[0];
      var dates = shared.indexOf('date') >= 0 ? (first.date ? formatDate(first.date) : 'Data a combinar') : items.map(function (it) {
        return it.name + ': ' + (it.date ? formatDate(it.date) : 'Data a combinar');
      }).join('; ');
      tail.push(field('Para quando precisa?', dates, en));
      tail.push(field('Receção', word(PICKUP, en), en));
      if (tail.length) blocks.push(tail);
    }
    if (opts.extra) blocks.push(opts.extra);
    blocks.push(CLOSING[en ? 1 : 0]);
    return compose(blocks);
  }

  function buildMessage(order) {
    return orderText([{
      name: order.name, variant: order.variant, topping: order.syrup, flavours: order.flavours, custom: order.custom, cakeMessage: order.cakeMessage,
      quantity: order.quantity, date: order.date, reception: order.reception, unitCents: order.unitCents
    }], { language: order.language });
  }

  function selectionKey(path) {
    return 'larrysa:product-selection:v1:' + new URL(path, 'https://www.larrysasbakery.com').pathname;
  }

  function cleanSelection(value, today) {
    value = value || {};
    var quantity = Number(value.quantity);
    var clean = {
      options: Array.isArray(value.options) ? value.options.filter(function(v){return typeof v === 'string' && v.length <= 150;}).slice(0,3) : [],
      quantity: Number.isInteger(quantity) && quantity >= 1 && quantity <= 99 ? quantity : 1,
      date: typeof value.date === 'string' && dateAllowed(value.date, today || '') ? value.date : '',
      reception: PICKUP,
      syrup: typeof value.syrup === 'string' && value.syrup.length <= 150 ? value.syrup : '',
    };
    if (value.flavours !== undefined) clean.flavours = ['Canela','Coco','Doce de leite','Sortida'].indexOf(value.flavours)>=0 ? value.flavours : '';
    if (value.edit && typeof value.edit.line === 'string' && /^[A-Za-z0-9:_-]{1,200}$/.test(value.edit.line) && Number.isSafeInteger(Number(value.edit.variantId)) && Number(value.edit.variantId) > 0) clean.edit = {line:value.edit.line,variantId:Number(value.edit.variantId)};
    return clean;
  }

  function saveSelection(path, value) {
    try {
      var clean=cleanSelection(value),raw=window.sessionStorage.getItem(selectionKey(path));
      if (value && !Object.prototype.hasOwnProperty.call(value,'edit') && raw) {
        var previous=cleanSelection(JSON.parse(raw));if(previous.edit)clean.edit=previous.edit;
      }
      window.sessionStorage.setItem(selectionKey(path), JSON.stringify(clean));
      return true;
    } catch (error) { return false; }
  }

  function readSelection(path, today) {
    try {
      var raw = window.sessionStorage.getItem(selectionKey(path));
      return raw ? cleanSelection(JSON.parse(raw), today) : null;
    } catch (error) { return null; }
  }

  function validSharedSelection(value, today) {
    if (!value || value.v !== 1 || !Array.isArray(value.options) || value.options.length > 3) return null;
    if (!value.options.every(function(v){return typeof v === 'string' && v.length > 0 && v.length <= 150 && !/[<>\x00-\x1f]/.test(v);})) return null;
    if (!Number.isInteger(value.quantity) || value.quantity < 1 || value.quantity > 99) return null;
    if (typeof value.date !== 'string' || !dateAllowed(value.date, today)) return null;
    if (['', PICKUP, 'Levantamento na Pontinha', 'Entrega por estafeta de carro'].indexOf(value.reception) < 0) return null;
    if (value.flavours !== undefined && ['Canela','Coco','Doce de leite','Sortida'].indexOf(value.flavours)<0) return null;
    var clean={options:value.options.slice(),quantity:value.quantity,date:value.date,reception:PICKUP,syrup:''};
    if(value.flavours !== undefined) clean.flavours=value.flavours;
    return clean;
  }

  function parseSelection(hash, today) {
    if (typeof hash !== 'string' || hash.indexOf('#selecao=') !== 0 || hash.length > 4000) return null;
    try { return validSharedSelection(JSON.parse(decodeURIComponent(hash.slice(9))), today); }
    catch (error) { return null; }
  }

  function selectionUrl(base, value, today) {
    var payload={v:1,options:value.options,quantity:value.quantity,date:value.date || '',reception:value.reception || ''};
    if(value.flavours) payload.flavours=value.flavours;
    if (!validSharedSelection(payload,today)) return null;
    try {
      var url=new URL(base);
      if (url.protocol !== 'https:' || !/^\/products\/[^/]+$/.test(url.pathname)) return null;
      url.hash='selecao='+encodeURIComponent(JSON.stringify(payload));
      return url.href;
    } catch(error) { return null; }
  }

  async function shareSelection(url, title, status) {
    var t=window.larrysaT || function(s){return s;};
    if (!url) {status.textContent=t('Reveja a seleção e a data antes de partilhar.');return;}
    if (navigator.share) {
      try {await navigator.share({title:title,url:url});return;}
      catch(error){if(error && error.name==='AbortError')return;}
    }
    try {await navigator.clipboard.writeText(url);status.textContent=t('Ligação da seleção copiada.');}
    catch(error){
      var input=document.createElement('input');input.value=url;input.readOnly=true;
      input.setAttribute('aria-label',t('Ligação da seleção para copiar'));input.style.width='100%';
      status.replaceChildren(input);input.focus();input.select();
    }
  }

  window.LarrysaWa = { opening: OPENING, closing: CLOSING, field: field, compose: compose, money: money, word: word, formatDate: formatDate, itemLines: itemLines, itemTotal: itemTotal, orderText: orderText, isCustomTopping: isCustomTopping, toppingText: toppingText };
  window.LarrysaProductOrder = { buildMessage: buildMessage, orderText: orderText, isCustomTopping: isCustomTopping, extraCents: extraCents, formatExtra: formatExtra, dateAllowed: dateAllowed, cleanSelection: cleanSelection, saveSelection: saveSelection, readSelection: readSelection, selectionUrl: selectionUrl, parseSelection: parseSelection, shareSelection: shareSelection };
})();
